// src/routes/TestConnection.js
import React, { useEffect, useState } from "react";
import "./style.css";

const TestConnection = () => {
  const [message, setMessage] = useState("Loading...");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_PATH}/test-connection`)
      .then((response) => response.text())
      .then((data) => {
        setMessage(data);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        setMessage("Error fetching data.");
      });
  }, []);

  return (
    <div className="test-connection">
      <h1>Test Connections</h1>
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

export default TestConnection;
